import React from 'react'
import { FormattedMessage, defineMessages, useIntl } from 'react-intl'
import { Field, FieldProps } from 'formik'
import { Box, H2, Grid, GridCell, Input, FormField } from '../../../components'
import { City as CityIcon } from '@urbaninfrastructure/react-icons'
import { Values } from '../types'
import { labelMessages } from '../messages'

function validateAddress(value) {
  let error
  if (!value) {
    error = 'ADDRESS_REQUIRED'
  }
  return error
}

function validateZip(value) {
  let error
  if (!value) {
    error = 'ZIP_REQUIRED'
  }
  return error
}

function validateCity(value) {
  let error
  if (!value) {
    error = 'CITY_REQUIRED'
  }
  return error
}

export const messages = defineMessages({
  title: {
    id: 'modules.Registration.OfficeStep.title',
    defaultMessage: 'Office address',
  },
  ADDRESS_REQUIRED: {
    id: 'modules.Registration.OfficeStep.ADDRESS_REQUIRED',
    defaultMessage: 'Address is required',
  },
  ZIP_REQUIRED: {
    id: 'modules.Registration.OfficeStep.ZIP_REQUIRED',
    defaultMessage: 'Zip is required',
  },
  CITY_REQUIRED: {
    id: 'modules.Registration.OfficeStep.CITY_REQUIRED',
    defaultMessage: 'City is required',
  },
})

const OfficeStep = () => {
  const intl = useIntl()
  return (
    <Box flex={1}>
      <Box textAlign="center" mb="sm">
        <CityIcon size="80px" color="primary" />
        <H2 mb={0} typoStyle="md" mt="sm">
          <FormattedMessage {...messages.title} />
        </H2>
      </Box>
      <Field name="address" validate={validateAddress}>
        {({ field, form }: FieldProps<Values['address'], Values>) => {
          const error = form.touched[field.name] && form.errors[field.name]
          const errorMessage = error && messages[error] && (
            <FormattedMessage {...messages[error]} />
          )
          return (
            <FormField
              wrapperProps={{ mb: 'sm' }}
              label={intl.formatMessage(labelMessages.address)}
              errorMessage={errorMessage}
            >
              <Input id={field.name} {...field} alternative autoFocus />
            </FormField>
          )
        }}
      </Field>
      <Grid justifyContent="center">
        <GridCell width={{ xs: 1, sm: 1 / 2 }}>
          <Field name="zipCode" validate={validateZip}>
            {({ field, form }: FieldProps<Values['zipCode'], Values>) => {
              const error = form.touched[field.name] && form.errors[field.name]
              const errorMessage = error && messages[error] && (
                <FormattedMessage {...messages[error]} />
              )
              return (
                <FormField
                  wrapperProps={{ mb: 'sm' }}
                  label={intl.formatMessage(labelMessages.zipCode)}
                  errorMessage={errorMessage}
                >
                  <Input id={field.name} {...field} alternative />
                </FormField>
              )
            }}
          </Field>
        </GridCell>
        <GridCell width={{ xs: 1, sm: 1 / 2 }}>
          <Field name="city" validate={validateCity}>
            {({ field, form }: FieldProps<Values['city'], Values>) => {
              const error = form.touched[field.name] && form.errors[field.name]
              const errorMessage = error && messages[error] && (
                <FormattedMessage {...messages[error]} />
              )
              return (
                <FormField
                  wrapperProps={{ mb: 'sm' }}
                  label={intl.formatMessage(labelMessages.city)}
                  errorMessage={errorMessage}
                >
                  <Input id={field.name} {...field} alternative />
                </FormField>
              )
            }}
          </Field>
        </GridCell>
      </Grid>
    </Box>
  )
}

export default OfficeStep
